import React, { useEffect } from "react";
  import { useNavigate } from "react-router-dom";
import "./SubStyle.css"
import Img1 from "../images/Reg-2.webp";
import Img2 from "../images/assessment-2.webp";
import Img3 from "../images/assessment-3.webp";
import choose1 from "../images/whychoose1.webp";
import choose2 from "../images/whychoose2.webp";

const CQC_Mock = () => {

    const navigate = useNavigate();
  const handleSeeMore = () => {
    navigate("/", {
      state: { scrollToContact: true },
    });
  };
   const handleSeeMore2 = () => {
    navigate("/services", {
      state: { scrollToContact: true },
    });
  };

  const data = [
  {
    image: Img1,
    title: "Realistic Assessment",
    description:
      "Experience an inspection mirroring CQC's methodology, providing an accurate compliance overview.",
  },
  {
    image: Img2,
    title: "Tailored Recommendations",
    description:
      "Receive practical, specific advice to address identified gaps and enhance your service.",
  },
  {
    image: Img3,
    title: "Supportive Guidance",
    description:
      "Benefit from a constructive, non-critical approach focused on continuous improvement.",
  },
];

const services = [
  {
    title: "Step 1: Initial consultation",
    description:
      "We begin with a consultation to understand your service, objectives, and any specific areas of concern you may have within the business.",
  },
  {
    title: "Step 2: On-site or remote assessment",
    description:
      "We conduct a comprehensive assessment, mirroring a real-life CQC Inspection. We also speak with staff and observe care delivery.",
  },
  {
    title: "Step 3: Detailed report & action plan",
    description:
      "You receive a detailed report outlining strengths, areas for improvement, prioritised recommendations, and a practical action plan.",
  },
  {
    title: "Step 4: Ongoing support (optional)",
    description:
      "We can provide continued support to help implement improvements and prepare confidently for your official CQC inspection.",
  },
];


  // open page on top //
     useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
      // open page on top // 




  return (
    <>
     <section className="Allowances-section">
     <h1 className="Allowances-title">Prepare with confidence CQC Mock Inspections</h1>
      <p className="Allowances-pera">Ensure your care service is inspection-ready with our expert CQC Mock
         Inspections. Gain clarity,<br/> identify strengths, and address challenges before the real CQC visit.</p>
         <div className="btn-container">
        <button className="SubServices-btn" onClick={handleSeeMore}><a>Request a mock inspection</a></button>
     </div>
    </section>

     <section className='Mock-Inspections'>
      <div className='Mock-container'>
        <div className='Mock-title'>What is a CQC Mock Inspection?</div>
        <p className='Mock-Pera'>A CQC Mock Inspection is a realistic, independent assessment of your service that mirrors 
          the way the Care Quality Commission (CQC) carries out an inspection. Our experienced consultants review your 
          documentation, policies, records, governance systems, and day-to-day practices, while speaking with staff 
          and observing how care is delivered. The result is a clear picture of how your service is performing against
           CQC's expectations, highlighting both strengths and areas for improvement.</p>
           <p className='Mock-Pera'>What makes our Mock Inspection different is that it goes beyond simply identifying gaps. We provide practical,
             tailored recommendations and a prioritised action plan to help you address any issues before a real CQC 
             inspection. Our approach is supportive rather than critical, giving providers the confidence, knowledge,
              and guidance they need to improve compliance and quality.</p>
      </div>
     </section>
      <section className="assessment-section">
      <div className="assessment-container">
        {data.map((item, index) => (
          <div className="assessment-card" key={index}>
            <div className="assessment-image">
              <img src={item.image} alt={item.title} />
            </div>

            <div className="assessment-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
    <section className='mock-Insights'>
      <div className='Mock-content'>
        <h2 className='Mock-inlights-text'>Who benefits from a CQC Mock Inspection?</h2>
        <p className='Mock-inlights-pera'>Our CQC Mock Inspection service is valuable for all regulated care providers, including residential care homes,<br/>
         nursing homes, domiciliary care agencies, supported living services, and specialist care providers.</p>
      <button className="SubServices-btn" onClick={handleSeeMore2}><a>Explore our full range of services</a></button>
      </div>
    </section>
     <section className="whyChoose">
      <div className="container">

        {/* Image */}
        <div className="box imageBox">
          <img src={choose1} alt="Care Staff" />
        </div>

        {/* Content */}
        <div className="box contentBox">
          <h2>Why choose Total Care Advisory?</h2>

          <p>
            At Total Care Advisory, we understand that every service is
            different. Our experienced consultants have extensive knowledge of
            CQC regulations and inspection methodology, allowing us to deliver
            realistic, thorough, and impartial assessments.
          </p>

          <p>
            We don't just identify compliance issues—we work alongside you to
            understand the root causes and provide practical, achievable
            solutions that fit your service.
          </p>
        </div>

        {/* Content */}
        <div className="box contentBox">
          <h2>Benefits of a Mock Inspection</h2>

          <p>
            Following a CQC Mock Inspection, providers gain a clear,
            independent understanding of how their service is performing
            against CQC standards and where improvements are needed.
          </p>

          <p>
            Clients receive a detailed report highlighting strengths, areas of
            concern, and practical recommendations to address any compliance
            gaps.
          </p>

          <p>
            The inspection helps reduce the risk of unexpected findings during
            a real CQC visit by identifying issues before they become
            enforcement concerns.
          </p>
        </div>

        {/* Image */}
        <div className="box imageBox">
          <img src={choose2} alt="Meeting" />
        </div>

      </div>
    </section>

     <section className="Mock-process">
      <h2 className="process-title">Our CQC Mock Inspection process</h2>
      <p className="process-pera">Our comprehensive mock inspection service is designed to be thorough and supportive, guiding you every step of the way.</p>
      <button className="SubServices-btn" onClick={handleSeeMore}><a>Request a mock inspection</a></button>
      <div className="process-grid">
        {services.map((service, index) => (
          <div className="process-card" key={index}>
            <div className="process-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
   
    </>
  )
}
                            

export default CQC_Mock
